/* global google */

async function initFindYourLocation() {
	const resultsBlock = document.querySelector(
		'.block-location-finder-results'
	);

	// eslint-disable-next-line no-unused-vars
	const { AutocompleteService, AutocompleteSessionToken } =
		await google.maps.importLibrary('places');

	const inputs = document.querySelectorAll(
		'.block-find-your-location__input'
	);

	const formSubmitted = (e, autocomplete) => {
		let detail = {};

		if (e.currentTarget) {
			e.preventDefault();
			detail = { originalEvent: e };
		} else {
			detail = { autocomplete };
		}

		autocompletePlaceChanged(autocomplete);

		const submitEvent = new CustomEvent(
			'find-your-location-form-submitted',
			{
				detail,
			}
		);

		window.dispatchEvent(submitEvent);
	};

	const autocompletePlaceChanged = (autocomplete) => {
		const place = autocomplete.getPlace();

		if (!place?.address_components?.length > 0) {
			return;
		}

		let state;
		let city;
		let zip;

		place.address_components.forEach((addressComponent) => {
			if (!addressComponent.types || !addressComponent.long_name) {
				return;
			}

			if (
				-1 !==
				addressComponent.types.indexOf('administrative_area_level_1')
			) {
				state = addressComponent.long_name;
			}

			if (-1 !== addressComponent.types.indexOf('locality')) {
				city = addressComponent.long_name;
			}

			if (-1 !== addressComponent.types.indexOf('postal_code')) {
				zip = addressComponent.long_name;
			}
		});

		autocomplete.zipInput.value = '';
		autocomplete.cityInput.value = '';
		autocomplete.stateInput.value = '';
		autocomplete.latInput.value = place?.geometry?.location?.lat() ?? '';
		autocomplete.lngInput.value = place?.geometry?.location?.lng() ?? '';

		autocomplete.zipInput.disabled = true;
		autocomplete.cityInput.disabled = true;
		autocomplete.stateInput.disabled = true;

		if (autocomplete.latInput.value) {
			autocomplete.latInput.disabled = false;
		} else {
			autocomplete.latInput.disabled = true;
		}

		if (autocomplete.lngInput.value) {
			autocomplete.lngInput.disabled = false;
		} else {
			autocomplete.lngInput.disabled = true;
		}

		if (zip) {
			autocomplete.zipInput.value = zip;
			autocomplete.zipInput.disabled = false;
		} else if (city) {
			autocomplete.cityInput.value = city;
			autocomplete.cityInput.disabled = false;

			if (state) {
				autocomplete.stateInput.value = state;
				autocomplete.stateInput.disabled = false;
			}
		} else if (state) {
			autocomplete.stateInput.value = state;
			autocomplete.stateInput.disabled = false;
		}

		if (autocomplete.formElement) {
			const detail = { autocomplete };

			const submitEvent = new CustomEvent(
				'find-your-location-form-submitted',
				{
					detail,
				}
			);

			window.dispatchEvent(submitEvent);
		}
	};

	const inputChanged = (e) => {
		const allInputFields = e.currentTarget.parentElement.children;

		Array.from(allInputFields).forEach((inputField) => {
			if (e.currentTarget === inputField) {
				return;
			}

			inputField.value = '';
		});
	};

	const updateUrl = (form) => {
		if (!resultsBlock || !form.children) {
			return;
		}

		const url = new URL(window.location.href);

		Array.from(form.children).forEach((input) => {
			if (!input.name) {
				return;
			}

			if (input.value) {
				url.searchParams.set(input.name, input.value);
			} else {
				url.searchParams.delete(input.name);
			}
		});

		window.history.pushState({}, '', url);
	};

	const autocompleteDropdownInitialized = (e) => {
		const autoCompleteContainer = document.querySelector('.pac-container');

		if (!autoCompleteContainer) {
			return;
		}

		const input = e.currentTarget;

		input.removeEventListener('focus', autocompleteDropdownInitialized);

		autoCompleteContainer.setAttribute('role', 'listbox');
		autoCompleteContainer.id = 'location-finder-dropdown';
		input.setAttribute('aria-controls', 'location-finder-dropdown');
		input
			.closest('.block-find-your-location')
			.appendChild(autoCompleteContainer);

		const observer = new MutationObserver((mutationsList) => {
			mutationsList.forEach((mutation) => {
				if (mutation.type === 'childList') {
					if (mutation.addedNodes.length > 0) {
						mutation.addedNodes.forEach((addedNode) => {
							if (!addedNode.classList.contains('pac-item')) {
								return;
							}

							if (!addedNode.hasAttribute('role')) {
								addedNode.setAttribute('role', 'option');
							}

							if (!addedNode.id) {
								addedNode.id = `location-finder-dropdown-option-${Array.prototype.indexOf.call(
									addedNode.parentNode.children,
									addedNode
								)}`;
							}
						});
					}
					//console.log('A child node has been added or removed.');
				} else if ('attributes' === mutation.type) {
					if ('style' === mutation.attributeName) {
						if ('none' === mutation.target?.style?.display) {
							input.setAttribute('aria-expanded', 'false');
						} else {
							input.setAttribute('aria-expanded', 'true');

							if ('0px' !== mutation.target.style.left) {
								mutation.target.style.left = '0px';
								mutation.target.style.top = '100%';

								const computedStyle = getComputedStyle(
									mutation.target
								);

								if (
									'rgba(0, 0, 0, 0)' ===
									computedStyle?.backgroundColor
								) {
									mutation.target.style.position = 'relative';
									mutation.target.style.top = 'auto';
								}
							}
						}
					} else if ('class' === mutation.attributeName) {
						if (
							mutation?.target?.classList.contains(
								'pac-item-selected'
							)
						) {
							input.setAttribute(
								'aria-activedescendant',
								mutation.target?.id
							);

							Array.from(
								mutation.target.parentElement.children
							).forEach((unSelectedOption) => {
								unSelectedOption.setAttribute(
									'aria-selected',
									'false'
								);
							});

							mutation.target.setAttribute(
								'aria-selected',
								'true'
							);
						}
					}
				}
			});
		});

		observer.observe(autoCompleteContainer, {
			childList: true,
			attributes: true,
			subtree: true,
		});
	};

	if (inputs.length > 0) {
		inputs.forEach((input) => {
			const options = {
				componentRestrictions: { country: ['us', 'ca'] },
				fields: ['address_components', 'geometry'],
				strictBounds: false,
			};

			const allInputFields = input.parentElement.children;

			options.formElement = input.parentElement;

			Array.from(allInputFields).forEach((inputField) => {
				if (!inputField.name) {
					return;
				}

				if ('state' === inputField.name) {
					options.stateInput = inputField;
				} else if ('city' === inputField.name) {
					options.cityInput = inputField;
				} else if ('zip' === inputField.name) {
					options.zipInput = inputField;
				} else if ('lat' === inputField.name) {
					options.latInput = inputField;
				} else if ('lng' === inputField.name) {
					options.lngInput = inputField;
				} else if ('l' === inputField.name) {
					options.lInput = inputField;
				}
			});

			const sessionToken =
				new google.maps.places.AutocompleteSessionToken();

			const autocomplete = new google.maps.places.Autocomplete(
				input,
				options,
				sessionToken
			);

			input.addEventListener('input', inputChanged);
			input.addEventListener('focus', autocompleteDropdownInitialized);

			google.maps.event.addListener(autocomplete, 'place_changed', () => {
				autocompletePlaceChanged(autocomplete);
			});

			input.addEventListener('keydown', (e) => {
				if (13 === e.keyCode) {
					e.preventDefault();
					const form = e.currentTarget.closest('form');

					if (form) {
						setTimeout(() => {
							updateUrl(form);

							if (resultsBlock) {
								formSubmitted(e, autocomplete);
							} else {
								form.submit();
							}
						}, 250);
					}
				}
			});

			input.parentElement.addEventListener('submit', (e) => {
				updateUrl(e.currentTarget);

				if (resultsBlock) {
					formSubmitted(e, autocomplete);
				}
			});
		});
	}
}

window.addEventListener('google-maps-loaded', initFindYourLocation);
